/**
 * Query Key factory for all patient queries.
 *
 * @module Patient
 */

import { Pagination } from "@customTypes/index";


export const patientQKeys = {
  all: () => ["patients"] as const,

  allWithFilters: (filters: {
    pagination?: Partial<Pagination>;
    search?: string;
    fields?: string[];
  }) => [...patientQKeys.all(), { ...filters }] as const,

  singlePatients: () => [...patientQKeys.all(), "singlePatient"] as const,

  singlePatient: (patientId: string) =>
    [...patientQKeys.singlePatients(), patientId] as const,

  footnotes: () => [...patientQKeys.singlePatients(), "footnotes"] as const,

  footnote: (patientId: string) =>
    [...patientQKeys.footnotes(), patientId] as const,

  allergies: () => [...patientQKeys.singlePatients(), "allergies"] as const,

  allergy: (patientId: string) =>
    [...patientQKeys.allergies(), patientId] as const,

  medicalHistories: () =>
    [...patientQKeys.singlePatients(), "medicalHistories"] as const,

  medicalHistory: (patientId: string) =>
    [...patientQKeys.medicalHistories(), patientId] as const,

  surgeries: () => [...patientQKeys.singlePatients(), "surgeries"] as const,

  surgery: (patientId: string) =>
    [...patientQKeys.surgeries(), patientId] as const,

  phoneNumbers: () => [...patientQKeys.all(), "phoneNumber"] as const,

  phoneNumber: (phoneNumber: string) =>
    [...patientQKeys.phoneNumbers(), phoneNumber] as const,
};
